import Icon from "@ant-design/icons";

const Component = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 11 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9.5" r="1" stroke="currentColor" fill="none" />
      <path
        d="M3 1.5H7.5C8.60457 1.5 9.5 2.39543 9.5 3.5C9.5 4.60457 8.60457 5.5 7.5 5.5H3.5C2.39543 5.5 1.5 6.39543 1.5 7.5C1.5 8.60457 2.39543 9.5 3.5 9.5H8"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.5L8.5 9.5L6.5 11.5"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="1.5" cy="1.5" r="1" stroke="currentColor" fill="none" />
    </svg>
  );
};

export const FlowIcon = (props) => <Icon component={Component} {...props} />;
